<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Pencarian
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Nama</label>
          <b-form-input 
            v-model="filter.nama"
            placeholder="Nama"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Nomor Surat</label>
          <b-form-input 
            v-model="filter.nomor_surat"
            placeholder="Nomor Surat"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Jenis Cuti</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="filter.jenis_cuti_id"
            :options="leaveOptions"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Pilih Jenis Sidang"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <label>Status Pengajuan Cuti</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="filter.status_pengajuan_cuti_id"
            :options="leave2Options"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Pilih Status Jadwal Sidang"
          />
        </b-col>
      </b-row>
      
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button variant="primary" @click="cari()">Cari</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  getJenisCuti,
  getStatusPengajuan,
} from '@/connection-api/pengajuan-cuti/api'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
  },
  data() {
    return {
      leaveOptions: [],
      leave2Options: [],
      filter: {},
      count: 0,
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Sidang --' },
        ],
      },
      statusJadwalOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Jadwal Sidang --' },
        ],
      },
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  beforeCreate() {
    getJenisCuti()
      .then(response => {
        if (response.data.success == true) {
          //gunakan response.data.data
          this.leaveOptions = response.data.data.map(item => ({
            label: item.nama,
            value: item.id,
          }));
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data Jenis Cuti Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));

    getStatusPengajuan()
      .then(response => {
        if (response.data.success == true) {
          //gunakan response.data.data
          this.leave2Options = response.data.data.map(item => ({
            label: item.nama,
            value: item.id,
          }));
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data Jenis Cuti Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
  },
  methods: {
    cari()
    {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
